import { Outlet } from "react-router-dom";
import MigrationWizardDialog from "../../components/Finance/MigrationWizardDialog";

export default function FinancePage() {
  return (
    <div>
      <MigrationWizardDialog />
      <Outlet />
    </div>
  );
}
